import clsx from "clsx";

import { Icon } from "@atoms/icon";
import { Typography } from "@atoms/typography";

import classes from "./styles.module.scss";

import type { PropsWithChildren } from "react";

import type { IThemeColors } from "@theme";

import type { IHintTextProps } from "./types";

function getColor(
  disabled?: boolean,
  isInvalid?: boolean,
): { text: IThemeColors; icon: IThemeColors } {
  if (disabled === true) {
    return { text: "text-disabled-300", icon: "icon-disabled-300" };
  }
  if (isInvalid === true) {
    return { text: "state-error-base", icon: "state-error-base" };
  }
  return { text: "text-sub-600", icon: "icon-soft-400" };
}

export function HintText(props: PropsWithChildren<IHintTextProps>) {
  const { isInvalid, text, disabled, children, className } = props;

  const color = getColor(disabled, isInvalid);

  return (
    <div className={clsx("d-flex-column gap-6", className)}>
      {children}
      {text && (
        <div className={classes["hint-text"]}>
          <div className={"icon-wrapper"}>
            <Icon
              name={"InformationFill"}
              color={color.icon}
              fontSize={"fs-16"}
            />
          </div>
          <Typography themeColor={color.text} fontType={"paragraph-x-small"}>
            {text}
          </Typography>
        </div>
      )}
    </div>
  );
}
